import { useQuery } from 'react-query';
import { useDebounce } from 'react-use';
import { useState } from 'react';
import { getAirlineSuggestions, getAirportSuggestions, } from '@/libs/api/getAutocompleteSuggestions';
import { MIN } from '@/libs/constants';
const getSuggestionsFnMap = {
    airline: getAirlineSuggestions,
    airport: getAirportSuggestions,
};
export const sanitizeAutocompleteValue = (value) => value.replace(/^\s+/, '').replace(/\s{2,}/g, ' ');
export const useAutocompleteOptions = ({ type, value, isOpen, }) => {
    const searchValue = sanitizeAutocompleteValue(value);
    const [debouncedSearchValue, setDebouncedSearchValue] = useState(searchValue);
    useDebounce(() => setDebouncedSearchValue(searchValue), 300, [searchValue]);
    const { data: initialSuggestions = [], isFetching: isFetchingInitial } = useQuery([`${type}-suggestions`, ''], () => getSuggestionsFnMap[type](''), { staleTime: 5 * MIN, cacheTime: 10 * MIN });
    const { data: searchSuggestions = [], isFetching: isFetchingSearch } = useQuery([`${type}-suggestions`, debouncedSearchValue], () => getSuggestionsFnMap[type](debouncedSearchValue), {
        enabled: !!debouncedSearchValue,
        staleTime: 5 * MIN,
        cacheTime: 10 * MIN,
    });
    const suggestions = debouncedSearchValue
        ? searchSuggestions
        : initialSuggestions;
    const isDebouncing = searchValue !== debouncedSearchValue;
    const isLoading = isOpen && (isFetchingInitial || isFetchingSearch || isDebouncing);
    return {
        searchValue,
        debouncedSearchValue,
        suggestions,
        isLoading,
        setDebouncedSearchValue,
    };
};
